import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import { LocationsEnum } from '../enums/modules/routes'
import { BaseRouteEnum } from '@/enums/modules/routes'

// Vuex Modules to load
const LocationsStoreModule = () =>
  import(/* webpackChunkName: "Locations" */ '../store/modules/fulfillmentCenter')

// Components
const LocationsPlaceholder = () =>
  import(/* webpackChunkName: "Locations" */ '@/components/locations/LocationsPlaceholder')

const Access = () =>
  import(/* webpackChunkName: "Locations" */ '@/components/locations/Access')

const FulfillmentRules = () =>
  import(/* webpackChunkName: "Locations" */ '@/components/locations/FulfillmentRules')

const InventoryDistribution = () =>
  import(/* webpackChunkName: "Locations" */ '@/components/locations/InventoryDistribution')

const dynamicModuleRegistrationLocationsArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'fulfillmentCenter',
    module: LocationsStoreModule,
    store,
    modulePath: 'fulfillmentCenter'
  }
}

export default [
  {
    path: '/locations',
    name: LocationsEnum.LocationsPlaceholder,
    component: LocationsPlaceholder,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationLocationsArgs()).then(
        () => next()
      )
    },
    meta: { showSideNav: true },
    children: [
      {
        path: '/locations/access',
        name: LocationsEnum.Access,
        component: Access,
        beforeEnter (_to, _from, next) {
          // if a subaccount user of a powered by account tries to load locations access information
          // redirect them to the Dashboard instead
          const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
          if (isPoweredBySubAccountUser) {
            next({ name: BaseRouteEnum.DashboardV2 })
          } else {
            next()
          }
        },
        meta: { showSideNav: true }
      },
      {
        path: '/locations/fulfillment',
        component: FulfillmentRules,
        name: LocationsEnum.FulfillmentRules,
        meta: { showSideNav: true }
      },
      {
        path: '/locations/inventory',
        name: LocationsEnum.InventoryDistribution,
        component: InventoryDistribution,
        beforeEnter (_to, _from, next) {
          // if a subaccount user of a powered by account tries to load inventory distribution information
          // redirect them to the Dashboard instead
          const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
          if (isPoweredBySubAccountUser) {
            next({ name: BaseRouteEnum.DashboardV2 })
          } else {
            next()
          }
        },
        meta: { showSideNav: true }
      }
    ]
  }
]
